import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkuploadComponent } from './bulkupload/bulkupload.component';
import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { BulkInstoreSearch } from '@app/_services/bulkinstoresearch.pipe';

@NgModule({
  declarations: [BulkuploadComponent, BulkInstoreSearch],
  imports: [
    CommonModule,
    NgbPaginationModule,
    NgbAlertModule,
    FormsModule
  ]
})
export class BulkuploadModule { }
